// src/pages/VerifyCodePage.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { change_password, verifyCode } from "../services/auth";
import logo from "../assets/Logo_DMARCOne.png";

export default function ChangePasswordPage() {
  const navigate = useNavigate();
  const [correo, setCorreo] = useState("");
  const [codigo, setCodigo] = useState("");
  const [plain_password, setPassword] = useState("");
  const [password_validation, setPasswordValidation] = useState("");
  const [verificado, setVerificado] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [msg, setMensaje] = useState("");

  useEffect(() => {
    const correoGuardado = localStorage.getItem("correo_validacion_pendiente");
    if (!correoGuardado) {
      navigate("/login");
      return;
    }
    setCorreo(correoGuardado);
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setVerificado(false);
    setLoading(true);

    //localStorage.removeItem("correo_validacion_pendiente");
    try {
      const resp = await change_password(
        plain_password,
        password_validation,
        correo,
        codigo,
      );
      setSuccess(resp.success);
      setMensaje(resp.detail);
      setVerificado(true);
    } catch (err) {
      console.error("[ChangePasswordPage] Error", JSON.stringify(err.message));
    } finally {
      setLoading(false);
    }
  };

  const volverAlLogin = () => {
    localStorage.removeItem("correo_validacion_pendiente");
    navigate("/login");
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{ backgroundColor: "#414142" }} // gris oscuro corporativo
    >
      <div
        className="w-full max-w-md rounded-2xl shadow-xl p-8"
        style={{
          backgroundColor: "#FFFFFF",
          border: "1px solid #E5E7EB",
        }}
      >
        {/* Logo */}
        <div className="flex justify-center mb-6">
          <img src={logo} alt="DMARCONE" className="w-60 h-auto" />
        </div>

        <h1
          className="text-xl font-semibold text-center mb-1"
          style={{ color: "#414142" }}
        >
          Recuperación de contraseña
        </h1>

        <p className="text-sm text-center mb-6" style={{ color: "#6B7280" }}>
          Ingresa el código enviado a:
          <br />
          <span className="font-medium" style={{ color: "#414142" }}>
            {correo}
          </span>
        </p>

        {msg && success == true && (
          <div className="mb-4 rounded-md bg-green-50 border border-green-200 px-3 py-2 text-sm text-green-700">
            {msg}
          </div>
        )}

        {msg && success == false && (
          <div className="mb-4 rounded-md bg-red-50 border border-red-200 px-3 py-2 text-sm text-red-700">
            {msg}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              className="block text-sm font-medium mb-1"
              style={{ color: "#414142" }}
            >
              Código de verificación
            </label>
            <input
              type="text"
              value={codigo}
              onChange={(e) => setCodigo(e.target.value)}
              required
              className="w-full rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#00C4CC] focus:border-[#00C4CC]"
              style={{
                borderColor: "#D1D5DB",
                color: "#414142",
              }}
              placeholder="Ej: 123456"
            />
          </div>

          <div>
            <label
              className="block text-sm font-medium mb-1"
              style={{ color: "#414142" }}
            >
              Contraseña nueva
            </label>
            <input
              type="password"
              value={plain_password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#00C4CC] focus:border-[#00C4CC]"
              style={{
                borderColor: "#D1D5DB",
                color: "#414142",
              }}
              placeholder="••••••••"
            />
          </div>

          <div>
            <label
              className="block text-sm font-medium mb-1"
              style={{ color: "#414142" }}
            >
              Valide su contraseña
            </label>
            <input
              type="password"
              value={password_validation}
              onChange={(e) => setPasswordValidation(e.target.value)}
              required
              className="w-full rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#00C4CC] focus:border-[#00C4CC]"
              style={{
                borderColor: "#D1D5DB",
                color: "#414142",
              }}
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-lg text-white text-sm font-medium py-2.5 transition disabled:opacity-50 disabled:cursor-not-allowed"
            style={{
              backgroundColor: "#00C4CC",
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#00AEB5")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#00C4CC")}
          >
            {loading ? "Verificando..." : "Validar código"}
          </button>
        </form>

        <button
          onClick={volverAlLogin}
          className="w-full rounded-lg mt-4 text-xs transition"
          style={{
            color: "#6B7280",
          }}
          onMouseEnter={(e) => (e.target.style.color = "#414142")}
          onMouseLeave={(e) => (e.target.style.color = "#6B7280")}
        >
          Volver al inicio de sesión
        </button>
      </div>
    </div>
  );
}
